import "./listRoomItem.css";
import { RoomItemList } from "src/Components";
import API from "src/API2";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcPlus = () => <Svg><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>;

const ListRoomItem = () => {
  const [floors, setFloors] = useState([]);
  const [roomtypes, setRoomtypes] = useState([]);

  useEffect(() => {
    API.get("floors").then((r) => setFloors(r.data.floors || [])).catch(() => {});
    API.get("rooms").then((r) => setRoomtypes(r.data.rooms || [])).catch(() => {});
  }, []);

  const handleCreate = () => {
    if (floors.length === 0 || roomtypes.length === 0) {
      toast.error("Create floors and room types first.");
    } else {
      window.location.href = "roomItem/create";
    }
  };

  return (
    <div className="ri-page">
      <header className="ri-hero">
        <div>
          <span className="ri-hero__eyebrow">Property setup</span>
          <h1 className="ri-hero__title">Rooms</h1>
          <p className="ri-hero__sub">
            Every individual room in your property — assign each one to a floor
            and room type so reservations can be allocated correctly.
          </p>
        </div>
        <div className="ri-hero__actions">
          <button onClick={handleCreate} className="ri-btn ri-btn--primary">
            <IcPlus /> Add rooms
          </button>
        </div>
      </header>

      <RoomItemList />
    </div>
  );
};

export default ListRoomItem;
